import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "./style.scss";
import * as PageRoutes from "../../../utils/route_pages";
import * as Assets from "../../../utils/svg_assets";
import { dateFormater } from "../../../utils/utilities";
import TopNavigation from "../../../components/TopNavigation";
import { useParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import * as Icon from 'react-bootstrap-icons';
import {
  ConfirmationDialog,
  InformationDialog,
} from "../../../components/DialogCollection";
import BwipJs from "bwip-js";
import Countdown, { zeroPad } from "react-countdown";
import parse from "html-react-parser";
import ApiUtils from "../../../utils/api_utils";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";
const MyVoucherDetail = (props) => {
  const { getVoucherDetails, reward_myvouchers_detail, useVoucher } = props;
  const { reward } = reward_myvouchers_detail;
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openInfoDialog, setOpenInfoDialog] = useState(false);
  const [isDisabledUsed, setIsDisabledUsed] = useState(false);
  const [openInfoClipboard, setopenInfoClipboard] = useState(false);

  const [valueLink, setValueLink] = useState('');

  let { voucherId } = useParams();
  let voucherText = reward_myvouchers_detail.evoucher;
  const rendererCountdown = ({ days, hours, minutes, seconds }) => {
    return (
      <span>
        {days} d : {zeroPad(hours, 2)} hr : {zeroPad(minutes, 2)} min :{" "}
        {zeroPad(seconds, 2)} sec
      </span>
    );
  };

  const countdownDate = new Date(
    reward_myvouchers_detail.evoucher_valid_until
      ? reward_myvouchers_detail.evoucher_valid_until
      : Date.now()
  );

  useEffect(() => {
    getVoucherDetails({ id: voucherId });
  }, []);

  useEffect(() => {
    if (reward_myvouchers_detail.is_url) {
      var el = document.createElement('div');
      el.innerHTML = reward_myvouchers_detail.evoucher;
      el.getElementsByTagName('a');
      setValueLink(el.getElementsByTagName('a')[0].href);
    }
    try {
      // The return value is the canvas element
      BwipJs.toCanvas("bar_code", {
        bcid: "code128",
        text: reward_myvouchers_detail?.evoucher,
      });

    } catch (e) {
      // `e` may be a string or Error object
    }
  }, [reward_myvouchers_detail]);

  const useVoucherProcess = async () => {
    let dataPayload = {
      wallet_id: voucherId,
    };
    await useVoucher(dataPayload).then((result) => {
      setOpenConfirmDialog(false);
      if (result.status === 200) {
        setOpenInfoDialog(true);
        setIsDisabledUsed(true);
      }
    });
  };

  return (
    <div className="myvoucher-page-detail">
      <div className="myvoucher-page-header">
        <TopNavigation
          titlePage={"E-Voucher"}
          toPath={PageRoutes.myVoucher}
          setBorder={true}
          showRightIcon={false}
          iconLeft={Assets.iconBack}
          iconRight={Assets.iconFilter}
        />
      </div>
      <div className="myvoucher-page-content">
        <div className="merchant-name">{reward?.merchant?.name}</div>
        <div className="voucher-name">{reward?.name}</div>
        <div className="myvoucher-logo">
          <img
            src={ApiUtils.validateImgUrl({ url: reward?.display_img_url })}
            className="image"
            alt="myvoucher_image"
          />
        </div>
        <div className="expired">
          {reward_myvouchers_detail.evoucher_valid_until
            ? `Expired on ${dateFormater(
              reward_myvouchers_detail.evoucher_valid_until,
              { day: "numeric", month: "long", year: "numeric" }
            )}`
            : ""}
        </div>
        <div className="expired-countdown">
          {reward_myvouchers_detail.evoucher_valid_until ? (
            <Countdown date={countdownDate} renderer={rendererCountdown} />
          ) : (
            ""
          )}
        </div>
        {reward_myvouchers_detail.is_url ? (
          <div>
            <div className="link-click">Your URL link E-Voucher Code:</div>
            <div>
              <Button variant="secondary" className="btn-click">
                {parse(
                  reward_myvouchers_detail?.evoucher
                    ? reward_myvouchers_detail?.evoucher
                    : ""
                )
                }
              </Button>

              <CopyToClipboard
                text={valueLink}
                onCopy={(valueLink, result) => {
                  toast.info("Copied Successfully", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                    hideProgressBar: true,
                    className: 'toast-success-container toast-success-container-after',
                  });
                  setTimeout(() => {
                    toast.info("Copied to Clipboard", {
                      position: toast.POSITION.BOTTOM_CENTER,
                      autoClose: 1000,
                      hideProgressBar: true,
                      className: 'toast-success-container toast-success-container-after',
                    })
                  }, 2500);
                }
                }
              >
                <Icon.Files className="text-danger icons-copy" size={30} />
              </CopyToClipboard>
            </div>
          </div>
        ) : (
          <div>
            <div className="barcode">
              {reward.redemption_type !== "electricity_topup" ? (
                <center>
                  <canvas
                    id="bar_code"
                    style={{ maxWidth: 350, height: 100 }}
                  ></canvas>
                </center>
              ) : (
                ""
              )}
              <p>{reward_myvouchers_detail?.evoucher}
                <CopyToClipboard
                  text={voucherText}
                  onCopy={(voucherText, result) => {
                    toast.info("Copied Successfully", {
                      position: toast.POSITION.BOTTOM_CENTER,
                      autoClose: 1500,
                      hideProgressBar: true,
                      className: 'toast-success-container toast-success-container-after',
                    });
                    setTimeout(() => {
                      toast.info("Copied to Clipboard", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1000,
                        hideProgressBar: true,
                        className: 'toast-success-container toast-success-container-after',
                      })
                    }, 2500);
                  }
                  }


                >
                  <Icon.Files className="text-danger" size={20} />
                </CopyToClipboard></p>
            </div>
          </div>
        )}
        <div className="howto"></div>
        <div className="d-grid gap-2">
          <Button
            className="btn-use-voucher"
            variant="danger"
            disabled={isDisabledUsed}
            onClick={() => setOpenConfirmDialog(true)}
          >
            Use Voucher
          </Button>
        </div>
        <div className="howto">
          <div className="myvoucher-howto">
            {parse(reward?.how_to_use ? reward?.how_to_use : "")}
          </div>
        </div>
      </div >
      <ConfirmationDialog
        cancelLabel="No"
        confirmLabel="Yes"
        message="Are you sure you want to use this voucher? (Make sure you have completed the transaction)"
        show={openConfirmDialog}
        onCancel={() => {
          setOpenConfirmDialog(false);
        }}
        onConfrim={useVoucherProcess}
      />
      <InformationDialog
        message="You have successfully use your voucher"
        closeLabel="OK"
        show={openInfoDialog}
        onHide={() => {
          setOpenInfoDialog(false);
        }}
      />
      <InformationDialog
        message="Success copy to Clipboard"
        closeLabel="OK"
        show={openInfoClipboard}
        onHide={() => {
          setopenInfoClipboard(false);
        }}
      />

    </div >
  );
};

const mapStateToProps = (state) => ({
  reward_myvouchers_detail: state.RewardSM.reward_myvouchers_detail,
});

const mapDispatchToProps = (dispatch) => ({
  getVoucherDetails: dispatch.RewardSM.getVoucherDetails,
  useVoucher: dispatch.RedeemSM.useVoucher,
});

export default connect(mapStateToProps, mapDispatchToProps)(MyVoucherDetail);
